<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    fill="none"
    viewBox="0 0 10 8"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.57995 7.7093L0.384888 4.51424L1.97678 2.92235L3.56866 4.51424L7.56532 0.517578L9.15721 2.10947L3.57995 7.7093Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 10,
  },
  height: {
    type: [String, Number],
    default: 8,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>